import { render, staticRenderFns } from "./RequestData.vue?vue&type=template&id=5522419c&"
import script from "./RequestData.vue?vue&type=script&lang=js&"
export * from "./RequestData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports